<div
  class="statistics-additional-action"
  [ngClass]="{
    'additional-action-no-sidebar' : isSidebarClosed
  }">
  <div class="btns-container">
    <div class="d-flex left-btns-container">
      <div class="date-picker-container" id="rangeMenu" (click)="openDatePicker('default')">
        <div [ngClass]="{'compare-active ' : comparisonActivated}" class="picker-conatiner first">
          <nb-icon class="calendar" icon="calendar" pack="icomoon"></nb-icon>
          <h3 class="chosen-period">
            <span class="d-none d-sm-inline-block" style="font-weight: 900">{{defaultButtonDateRangeTitle}}</span>
            <span class="d-none d-sm-inline-block range">{{defaultButtonDateRange}}</span>
          </h3>
          <button class="round-button">
            <nb-icon icon="edit" pack="icomoon"></nb-icon>
          </button>
        </div>
      </div>
      <app-tertiary-button
        [ngClass]="comparisonActivated ? 'compare-active' : ''"
        class="compare-tertiary"
        [text]="comparisonActivated ? 'compare_off' : 'compare'"
        [icon]="'statistics'"
        [iconSize]="20"
        (emitAction)="compareActiveHandler()">
      </app-tertiary-button>
      <div class="date-picker-container sec" id="rangeMenuCompare" *ngIf="compareButtonClicked" (click)="openDatePicker('compare')">
        <div [ngClass]="{'compare-active ' : comparisonActivated}" class="picker-conatiner">
          <nb-icon class="calendar" icon="calendar" pack="icomoon"></nb-icon>
          <h3 class="chosen-period">
            <span class="d-none d-sm-inline-block" style="font-weight: 900">{{compareButtonDateRangeTitle}}</span>
            <span class="d-none d-sm-inline-block range">{{compareButtonDateRange}}</span>
          </h3>
          <button class="round-button">
            <nb-icon icon="edit" pack="icomoon"></nb-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="export-to-csv-container">
      <button class="export-button statistics-menu-button global-transition" (click)="openModal()">
        <nb-icon class="file-icon" icon="file" pack="icomoon"></nb-icon>
        <p>{{ 'view_translations.export_and_reports' | translate }}</p>
      </button>
    </div>
  </div>

  <ng-template #rangePicker [ngIf]="isRangePickerVisible && isDefaultDatePicker" class="rangePicker">
    <div class="date-picker-wrapper">
      <app-statistics-range-picker
        (selectedDateRange)="getDateRangeForDefaultPicker($event)"
        [selectedPeriod]="selectedPeriodDates?.range ?? INITIAL_DEFAULT_PICKER_DATE_PERIOD"
        [dateRanges]="defaultPickerDateRanges"
        [currentDatePicker]="currentDatePicker"
        (closeRangePickerOut)="closeRangePicker()">
      </app-statistics-range-picker>
    </div>
  </ng-template>

  <ng-template #rangePicker [ngIf]="isRangePickerVisible && isCompareDatePicker" class="rangePicker">
    <div class="date-picker-wrapper">
      <app-statistics-range-picker
        (selectedDateRange)="getDateRangeForComparePicker($event)"
        [selectedPeriod]="compareSelectedPeriodDates?.range ?? INITIAL_COMPARE_PICKER_DATE_PERIOD"
        [dateRanges]="comparePickerDateRanges"
        [currentDatePicker]="currentDatePicker"
        (closeRangePickerOut)="closeRangePicker()">
      </app-statistics-range-picker>
    </div>
  </ng-template>
</div>
